<template>
  <div class="hcl-form-element-single-select">
    <Multiselect class="hcl-form-element-single-select-select" :class="{
      'is-valid': validationStatus === 'valid',
      'is-invalid': validationStatus === 'invalid'
    }" ref="fieldRef" v-model="dataFieldValue" :disabled="isReadOnly(props.definitionField.field)"
      :required="props.definitionField.field.required" :hidden="props.definitionField.field.hidden" label="text"
      :placeholder="fieldPlaceholder" :options="fieldLookup" :searchable="true" @keydown="handleKeydown">
      <template #nooptions>
        {{ fieldPlaceholderNoOptions }}
      </template>
    </Multiselect>
    <input type="hidden" :id="fieldName" :name="fieldName" :value="dataFieldValue"
      :widget="props.definitionField.field.widget?.widget" v-bind="generateDataAttributes" />
  </div>
</template>

<script setup lang="ts">
import { toRef, onMounted } from 'vue'

import { useElement } from '@/components/FormElement/element'

import Multiselect from '@vueform/multiselect'

interface Props {
  definitionField: any
  dataField: any
  dataLookup: any
  dropdownmode?: any
}

const props = withDefaults(defineProps<Props>(), {
  definitionField: undefined,
  dataField: undefined,
  dataLookup: undefined,
  dropdownmode: undefined
})

const {
  fieldRef,
  isReadOnly,
  fieldName,
  fieldLookup,
  fieldPlaceholder,
  fieldPlaceholderNoOptions,
  validationStatus,
  generateDataAttributes
} = useElement(props)

onMounted(() => {
  if (props.definitionField.field.focus) fieldRef.value.$refs.multiselect.focus()
})

const dataFieldValue = toRef(props.dataField, 'value')

const handleKeydown = (event: Event, instance: Multiselect) => {
  const keyboardEvent = event as KeyboardEvent
  if (keyboardEvent.key === 'Tab') {
    const multiselectInstance = fieldRef.value.$refs.multiselect
    const index = getIndexOfPointedOption(multiselectInstance)
    if (index > -1) {
      let allOptions = fieldLookup.value
      if (props.definitionField.field.group) {
        allOptions = fieldLookup.value.reduce((acc, group) => {
          return acc.concat(group.options)
        }, [])
      }
      dataFieldValue.value = allOptions[index].value
    } 
  }
}

function getIndexOfPointedOption(multiselectInstance: HTMLElement): number {
  const options = multiselectInstance.querySelectorAll(".multiselect-option")
  for (let i = 0; i < options.length; i++) {
    if (options[i].classList.contains("is-pointed")) {
      return i;
    }
  }
  return -1;
}
</script>

<style lang="scss">
.hcl-form-element-single-select {
  width: 100%;
}
</style>
